import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-120">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-radial-gold opacity-30 pointer-events-none" data-id="element-121" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-navy-900 border-2 border-gold-500/40 rounded-2xl p-8 md:p-12 text-center box-glow" data-id="element-123">
          <h2 className="text-3xl md:text-5xl font-serif text-white mb-6" data-id="element-124">
            Recupera tu soberanía energética hoy mismo.
          </h2>

          <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-125">
            El acceso completo al Protocolo 11:11 tiene un valor de lanzamiento
            diseñado para que no tengas que pensarlo dos veces.
          </p>

          <div className="mb-10" data-id="element-126">
            <p className="text-sm text-gold-400 uppercase tracking-widest mb-2 font-medium" data-id="element-127">
              🔥 Oferta de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-128">
              <span className="text-2xl text-gray-500 line-through font-serif" data-id="element-129">
                $27
              </span>
              <span className="text-6xl font-serif text-white font-bold" data-id="element-130">
                $6,39
              </span>
              <span className="text-xl text-gray-400 mt-4" data-id="element-131">USD</span>
            </div>
          </div>

          <div className="max-w-md mx-auto mb-8" data-id="element-132">
            <CTAButton fullWidth onClick={() => window.open('https://www.llavesdetualma.com/cart/52120657559834:1', '_blank')} data-id="element-133">
              DESCARGAR BLINDAJE 11:11 AHORA
            </CTAButton>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-134">
            <div className="flex items-center gap-2" data-id="element-135">
              <Lock className="w-4 h-4 text-gold-500" data-id="element-136" />
              <span data-id="element-137">Compra 100% segura</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-navy-700" data-id="element-138" />
            <div className="flex items-center gap-2" data-id="element-139">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-140" />
              <span data-id="element-141">Acceso inmediato a la descarga tras el pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}